import React from 'react';

export default function EquipmentSection({ id, eyebrow, title, children }) {
  return <section className="equipment-container equipment-section" id={id}>
    {eyebrow && <span className="equipment-eyebrow">{eyebrow}</span>}
    <h2>{title}</h2>
    {children}
  </section>;
}
